import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseSearchfilter'
})
export class CaseSearchfilterPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    }
     items = items.filter(item => item.issueCategoryName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.case_number.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.participantName.toLowerCase().indexOf(filter.toLowerCase()) !== -1  );
    return items;
}
}
